var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-messenger-container"},[_c('client-only',[_c('messenger-full')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }